import api_common from "@/helpers/api_common.js";

export default {
    // 一覧取得
    getList(apiconf, staff_id, page) {
        return api_common.callPostApi({
            conf: apiconf,
            path: "brand/list",
            query: { staff_id: staff_id, page: page },
        })
    },

    // 作成
    create(apiconf, staff_id, brand) {
        return api_common.callPostApi({
            conf: apiconf,
            path: "brand/create",
            query: { staff_id: staff_id, brand: brand },
        })
    },

    // 更新
    update(apiconf, staff_id, brand) {
        return api_common.callPostApi({
            conf: apiconf,
            path: "brand/update",
            query: { staff_id: staff_id, brand: brand },
        })
    },

    // コード生成
    newCode(apiconf, staff_id, conditions) {
        return api_common.callPostApi({
            conf: apiconf,
            path: "random/brandcd/create",
            query: { staff_id: staff_id, conditions: conditions },
        })
    },
}